import { useQuery } from "react-query";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectRelationshipsModel } from "../../services/relationships-data-service/Models"
import RelationshipsDataService from "../../services/relationships-data-service/RelationshipsDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters"
import { keys } from "./Keys";

export type UseObjectRelationshipsQueryParams = {
    groupID: number,
    eLynxObject: IeLynxObject
} & BaseUseQueryParameters<IObjectRelationshipsModel>;

export function useRelationships(params: UseObjectRelationshipsQueryParams) {
    return useQuery<IObjectRelationshipsModel, RestError>(
        keys.relationships(params.groupID, params.eLynxObject),
        ({ signal }) => {
            return RelationshipsDataService.getRelationships(params.groupID, params.eLynxObject, signal);
        },
        {
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds * 1000 : false
        }
    )
}